export default {
  namespaced: true,
  state: {
    map_id: localStorage.getItem('telemetry.map_id') || null,
    build_id:  localStorage.getItem('telemetry.build_id') || null,
    user_id: localStorage.getItem('telemetry.user_id') || null,
    session_id: localStorage.getItem('telemetry.session_id') || null,
    start_narration_node: localStorage.getItem('telemetry.start_narration_node') || null,
    finish_narration_node: localStorage.getItem('telemetry.finish_narration_node') || null,
    finish_event_id: localStorage.getItem('stelemetry.finish_event_id') || null,
    session_min_time: localStorage.getItem('telemetry.session_min_time') || '00:00:00',
    encounter_name: localStorage.getItem('telemetry.encounter_name') || null,
  },
  mutations: {
    SET_MAP_ID (state, map_id) {
      state.map_id = map_id
      if (map_id) {
        localStorage.setItem('telemetry.map_id', map_id)
      } else {
        localStorage.removeItem('telemetry.map_id')
      }
    },
    SET_BUILD_ID (state, build_id) {
      state.build_id = build_id
      if (build_id) {
        localStorage.setItem('telemetry.build_id', build_id)
      } else {
        localStorage.removeItem('telemetry.build_id')
      }
    },
    SET_USER_ID (state, user_id) {
      state.user_id = user_id
      if (user_id) {
        localStorage.setItem('telemetry.user_id', user_id)
      } else {
        localStorage.removeItem('telemetry.user_id')
      }
    },
    SET_SESSION_ID (state, session_id) {
      state.session_id = session_id
      if (session_id) {
        localStorage.setItem('telemetry.session_id', session_id)
      } else {
        localStorage.removeItem('telemetry.session_id')
      }
    },
    SET_START_NARRATION_NODE (state, start_narration_node) {
      state.start_narration_node = start_narration_node
      if (start_narration_node) {
        localStorage.setItem('telemetry.start_narration_node', start_narration_node)
      } else {
        localStorage.removeItem('telemetry.start_narration_node')
      }
    },
    SET_FINISH_NARATION_NODE (state, finish_narration_node) {
      state.finish_narration_node = finish_narration_node
      if (finish_narration_node) {
        localStorage.setItem('telemetry.finish_narration_node', finish_narration_node)
      } else {
        localStorage.removeItem('telemetry.finish_narration_node')
      }
    },
    SET_FINISH_EVENT_ID (state, finish_event_id) {
      state.finish_event_id = finish_event_id
      if (finish_event_id) {
        localStorage.setItem('telemetry.finish_event_id', finish_event_id)
      } else {
        localStorage.removeItem('telemetry.finish_event_id')
      }
    },
    SET_SESSION_MIN_TIME (state, session_min_time) {
      state.session_min_time = session_min_time
      if (session_min_time) {
        localStorage.setItem('telemetry.session_min_time', session_min_time)
      } else {
        localStorage.removeItem('telemetry.session_min_time')
      }
    },
    SET_ENCOUNTER_NAME (state, encounter_name) {
      state.encounter_name = encounter_name
      if (encounter_name) {
        localStorage.setItem('telemetry.encounter_name', encounter_name)
      } else {
        localStorage.removeItem('telemetry.encounter_name')
      }
    }
  }
}